"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoardModel = void 0;
var Model_1 = __importDefault(require("../Model"));
var array_1 = require("../../helpers/array");
var BoardModel = /** @class */ (function (_super) {
    __extends(BoardModel, _super);
    function BoardModel(board, getters) {
        var _this = _super.call(this, getters) || this;
        _this.id = board.id;
        _this.title = board.title;
        _this.description = board.description;
        _this.slug = board.slug;
        _this.articleByStudyCaseId = board.articleByStudyCaseId;
        _this.boardsDegreesByBoardId = board.boardsDegreesByBoardId || [];
        _this.boardsKnowledgesByBoardId = board.boardsKnowledgesByBoardId || [];
        _this.boardSectionsByBoardId = board.boardSectionsByBoardId || [];
        _this.boardsTeachersByBoardId = board.boardsTeachersByBoardId || [];
        _this.isPreregistered = board.isPreregistered;
        _this.hasPostgradMicrocertificateEnabled = board.hasPostgradMicrocertificateEnabled;
        _this.materialsByBoardId = board.materialsByBoardId || [];
        _this.readingsByBoardId = board.readingsByBoardId || [];
        _this.knowledgeAssociationsByBoardId = board.knowledgeAssociationsByBoardId || [];
        _this.syllabus = board.syllabus || '';
        _this.objectives = board.objectives || '';
        _this.methodology = board.methodology || '';
        _this.workload = board.workload;
        return _this;
    }
    BoardModel.prototype.getUserProgress = function () {
        var classrooms = this.getters.classroomsByBoardId(this.id);
        if (!classrooms.length)
            return 0;
        // There should not be a case in which this returns more than one classroom,
        // but there is no constraint between the user and a board by classroom.
        // So I'm returning the last classroom from that board in which the user
        // enrolled. (This solves the problem of reproving in a classroom).
        // TODO check if the user is enrolled in that classroom.
        return classrooms[classrooms.length - 1].progress;
    };
    BoardModel.prototype.knowledgesByType = function () {
        var _this = this;
        var knowledgeAssociations = this.knowledgeAssociationsByBoardId.map(function (knowledgeAssociationId) { return _this.getters.knowledgeAssociationById(knowledgeAssociationId); });
        return knowledgeAssociations.reduce(function (knowledges, knowledgeAssociation) {
            if (knowledgeAssociation.type === 'programmatic content')
                knowledges.programmaticContent.push(knowledgeAssociation.knowledge);
            else if (knowledgeAssociation.type === 'subject')
                knowledges.subject.push(knowledgeAssociation.knowledge);
            else if (knowledgeAssociation.type === 'degree knowledge') {
                knowledges.degreeKnowledge.push(knowledgeAssociation.knowledge);
            }
            return knowledges;
        }, { programmaticContent: [], subject: [], degreeKnowledge: [] });
    };
    Object.defineProperty(BoardModel.prototype, "readings", {
        get: function () {
            var _this = this;
            return this.readingsByBoardId.map(function (readingId) { return _this.getters.readingById(readingId); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BoardModel.prototype, "studyCase", {
        get: function () {
            if (!this.articleByStudyCaseId)
                return;
            return this.getters.articleById(this.articleByStudyCaseId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BoardModel.prototype, "boardsDegrees", {
        get: function () {
            var _this = this;
            return this.boardsDegreesByBoardId.map(function (boardsDegreeId) { return _this.getters.boardsDegreeById(boardsDegreeId); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BoardModel.prototype, "boardsKnowledges", {
        get: function () {
            var _this = this;
            return this.boardsKnowledgesByBoardId.map(function (boardsKnowledgeId) { return _this.getters.boardsKnowledgeById(boardsKnowledgeId); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BoardModel.prototype, "boardSections", {
        get: function () {
            return this.getters
                .boardSectionsByBoardId(this.id)
                .concat()
                .sort(array_1.positionAscending);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BoardModel.prototype, "materials", {
        get: function () {
            var _this = this;
            return this.materialsByBoardId.map(function (materialId) { return _this.getters.materialById(materialId); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BoardModel.prototype, "lists", {
        get: function () {
            var materials = this.materials.concat();
            var isSortable = materials.every(function (material) { return material.position !== null && material.position !== undefined; });
            if (isSortable) {
                materials = materials.sort(array_1.positionAscending);
            }
            return materials.reduce(function (acc, material) {
                if (material.list)
                    acc.push(material.list);
                return acc;
            }, []);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BoardModel.prototype, "teachers", {
        get: function () {
            var _this = this;
            return this.boardsTeachersByBoardId.map(function (boardsTeacherId) { return _this.getters.boardsTeacherById(boardsTeacherId).teacher; });
        },
        enumerable: false,
        configurable: true
    });
    return BoardModel;
}(Model_1.default));
exports.BoardModel = BoardModel;
